import type React from 'react';

import { useTranslation } from 'react-i18next';

import type { IconName } from '@similarweb/icons';
import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes } from '@similarweb/styles';

import { SignalType } from '../../../../domain/signal';
import { signalService } from '../../../../services/signal/signal';

import { StyledSignalItemHeader, StyledSignalItemHeaderText, StyledSignalItemHeaderTimeframe } from './styles';

const iconNamePerSignalType: Record<SignalType, IconName> = {
  [SignalType.AdNetwork]: 'ad',
  [SignalType.Technology]: 'computer-settings',
  [SignalType.News]: 'serp-news',
  [SignalType.Traffic]: 'overview',
  [SignalType.Intent]: 'fire-outline',
};

type Props = {
  type: SignalType;
  eventHappenedDaysAgo: number;
};

export const SignalHeader: React.FC<Props> = ({ type, eventHappenedDaysAgo }) => {
  const { t } = useTranslation();

  return (
    <StyledSignalItemHeader>
      <SWReactIcons iconName={iconNamePerSignalType[type]} size="xs" iconColor={colorsPalettes.bluegrey[500]} />
      <StyledSignalItemHeaderText>
        {t(`company.signals.item.type.${type.toLowerCase()}.title`)}
      </StyledSignalItemHeaderText>
      <StyledSignalItemHeaderTimeframe>
        {signalService.getSignalEventDate(eventHappenedDaysAgo)}
      </StyledSignalItemHeaderTimeframe>
    </StyledSignalItemHeader>
  );
};
